export default {
  RegularFund: 1, // kinh phí thường xuyên
  IrregularFund: 2, // kinh phí không thường xuyên
  BasicConstructFund: 3, // kinh phí xây dựng cơ bản
  NotReturnFund: 4, // kinh phí viện trợ không hoàn lại
  DebtForeignFund: 5, // kinh phí vay nợ nước ngoài
};
